import { useLocation } from "react-router-dom";
import WhatsAppIcon from "./WhatsAppIcon";

export const WHATSAPP_NUMBER = "16193876711";
export const WHATSAPP_MESSAGE =
  "Hi! I'm interested in the Olympia Posing & Presentation Program. I'd like to know about your current discounts and availability.";
export const WHATSAPP_CONSULTATION_MESSAGE =
  "Hi! I'm interested in the Olympia Posing & Presentation Program. I'd like to know about your current discounts and availability.";
export const WHATSAPP_POSING_MESSAGE =
  "Hi! I'm interested in the Olympia Posing & Presentation Program. I'd like to know about your current discounts and availability.";
export const WHATSAPP_NUTRITION_MESSAGE =
  "Hi! I'm interested in the Nutrition, Training & Contest Prep Coaching program. I'd like to know more about pricing, what's included, and how to get started.";

// wa.me opens the native app on mobile and WhatsApp Web on desktop.
export const buildWhatsAppLink = (message = WHATSAPP_MESSAGE) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

const FloatingWhatsAppButton = () => {
  const location = useLocation();

  // Hide on admin pages
  if (location.pathname.startsWith("/admin")) return null;

  return (
    <a
      href={buildWhatsAppLink()}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp for Discounts"
      data-testid="floating-whatsapp-btn"
      className="fixed bottom-5 right-5 sm:bottom-8 sm:right-8 z-[60] group"
    >
      {/* Pulse halo — luxury glow */}
      <span className="absolute inset-0 rounded-full bg-[#25D366]/40 animate-ping" />
      <span className="absolute inset-0 rounded-full bg-[#25D366]/20" />

      {/* Expanded pill (desktop ≥lg) + Compact circle (mobile & tablet) */}
      <span className="relative flex items-center gap-2 lg:gap-3 rounded-full bg-[#25D366] text-white pl-3 pr-3 lg:pl-4 lg:pr-5 py-3 lg:py-3.5 shadow-[0_12px_32px_-6px_rgba(37,211,102,0.6)] ring-1 ring-white/15 transition-all duration-300 group-hover:scale-105 group-hover:bg-[#1FB855] group-hover:shadow-[0_16px_40px_-6px_rgba(37,211,102,0.75)]">
        <WhatsAppIcon size={26} className="drop-shadow-sm flex-shrink-0" />
        <span className="hidden lg:inline text-[11px] xl:text-xs tracking-[0.22em] uppercase font-bold whitespace-nowrap">
          WhatsApp for Discounts
        </span>
      </span>

      {/* Mobile/tablet tooltip badge */}
      <span
        className="pointer-events-none absolute right-full top-1/2 -translate-y-1/2 mr-3 flex lg:hidden items-center gap-1.5 bg-black/90 border border-[#D4AF37]/40 text-white text-[10px] tracking-[0.18em] uppercase px-2.5 py-1.5 whitespace-nowrap font-bold"
      >
        <span className="w-1 h-1 rounded-full bg-[#25D366] animate-pulse" />
        Discounts
      </span>
    </a>
  );
};

export default FloatingWhatsAppButton;
